module.exports = __webpack_public_path__ + "img/Goto_Line_20px_Icon_black.711f0f6c.svg";